import { useQuery } from '@tanstack/react-query';

import type { DeploymentDetailResponse } from '@/shared/api/deploy';
import { getDeploymentStatus } from '@/shared/api/deploy';

export const DEPLOYMENT_DETAIL_QUERY_KEY = 'deploymentDetail';

export const useDeploymentDetail = (deploymentId: string | null, options?: { enabled?: boolean }) => {
  return useQuery<DeploymentDetailResponse>({
    queryKey: [DEPLOYMENT_DETAIL_QUERY_KEY, deploymentId],
    queryFn: () => getDeploymentStatus(deploymentId!),
    enabled: !!deploymentId && (options?.enabled ?? true),
    staleTime: 1000 * 10, // 10초간 fresh 상태 유지
    gcTime: 1000 * 60 * 5, // 5분간 캐시 유지 (구 cacheTime)
  });
};
